export default __webpack_public_path__ + "static/media/ser3.4ed6af31.svg";